import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';
import Reveal from '../common/Reveal';
import SectionHead from '../common/SectionHead';
import { useLang, usePageTitle } from '../../i18n/LanguageContext';

export default function Services() {
  const { t } = useLang();
  const s = t.services;
  usePageTitle(s.pageTitle);

  return (
    <>
      <PageHeader crumb={s.pageTitle} eyebrow={s.eyebrow} title={s.title} lead={s.lead} />

      <section className="section">
        <div className="container">
          <div className="grid grid--3">
            {s.items.map((it, i) => (
              <Reveal key={it.title} delay={(i % 3) * 80} className="card card--service">
                <span className="icon-tile">
                  <i className={it.icon} aria-hidden="true" />
                </span>
                <h3 className="card__title">{it.title}</h3>
                <p className="card__text">{it.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tint">
        <div className="container">
          <SectionHead title={s.processTitle} />
          <ol className="process">
            {s.process.map((p, i) => (
              <Reveal as="li" key={p.title} delay={i * 90} className="process__step">
                <span className="process__num">{i + 1}</span>
                <h3 className="card__title">{p.title}</h3>
                <p className="card__text">{p.text}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionHead title={s.valuesTitle} />
          <div className="grid grid--4">
            {s.values.map((v, i) => (
              <Reveal key={v.title} delay={i * 80} className="card card--use">
                <span className="icon-tile icon-tile--soft">
                  <i className={v.icon} aria-hidden="true" />
                </span>
                <h3 className="card__title">{v.title}</h3>
                <p className="card__text">{v.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tight">
        <div className="container">
          <Reveal className="cta-band">
            <div className="cta-band__copy">
              <h2>{s.ctaTitle}</h2>
              <p>{s.ctaText}</p>
            </div>
            <div className="cta-band__actions">
              <Link to="/contact?topic=development" className="btn btn--primary btn--lg">
                {t.common.talkToUs} <i className="fa-solid fa-arrow-right flip-rtl" aria-hidden="true" />
              </Link>
              <Link to="/portfolio" className="btn btn--outline btn--lg">
                {t.nav.work}
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
